module.exports = "/_next/static/images/9d8aa1b4693c0d40b65b26491ae08103-man-holding-two-phones@3x.jpg.webp";